import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { SelectWidgetWrapper } from '../common/select-widget/SelectWidgetWrapper.tsx';
import { getWidgetProps } from '../common/util/getWidgetProps.ts';
import { SingleSelectRadioComponent } from './component/SingleSelectRadioComponent.tsx';
import { SingleSelectSelectComponent } from './component/SingleSelectSelectComponent.tsx';
import { useSingleSelectWidgetOptions } from './hooks/useSingleSelectWidgetOptions.tsx';
import {
  type ISingleSelectWidget,
  SingleSelectKind,
} from './ISingleSelectWidget.ts';

export interface ISingleSelectWidgetComponentProps
  extends IWidgetComponentProps<ISingleSelectWidget> {}

export function SingleSelectWidgetComponent(
  props: ISingleSelectWidgetComponentProps,
) {
  const { widget } = props;

  const widgetOptions = getWidgetProps(props);

  const { options, componentOptions } = useSingleSelectWidgetOptions({
    widget,
    name: widgetOptions.name,
    preview: widgetOptions.preview,
  });

  return (
    <SelectWidgetWrapper {...props}>
      {widget.kind === SingleSelectKind.Radio ? (
        <SingleSelectRadioComponent
          {...props}
          options={options}
          componentOptions={componentOptions}
        />
      ) : (
        <SingleSelectSelectComponent
          {...props}
          options={options}
          componentOptions={componentOptions}
        />
      )}
    </SelectWidgetWrapper>
  );
}
